const getRandomElement = <T extends readonly unknown[] | unknown[]>(
  array: T,
): T[number] => array[Math.floor(Math.random() * array.length)];

export type THolidayDetail = {
  id: string;
  date: string;
  name: string;
  usersCount: number;
  users: {
    id: string;
    email: string;
    profile: {
      name: string;
      email: string;
      profilePicture: {
        url: string;
        placeholder: string;
      };
    };
    area: {
      id: string;
      name: string;
    };
    jobPosition: {
      id: string;
      name: string;
    };
    country: {
      id: string;
      name: string;
    };
  }[];
};
// Mock data arrays for random generation
const areas = [
  { id: 'eng', name: 'Engineering' },
  { id: 'sales', name: 'Sales' },
  { id: 'mkt', name: 'Marketing' },
  { id: 'hr', name: 'Human Resources' },
  { id: 'fin', name: 'Finance' },
  { id: 'ops', name: 'Operations' },
  { id: 'prod', name: 'Product' },
  { id: 'des', name: 'Design' },
];

const jobCategories = [
  { id: 'dev', name: 'Software Developer' },
  { id: 'pm', name: 'Product Manager' },
  { id: 'des', name: 'Designer' },
  { id: 'anal', name: 'Business Analyst' },
  { id: 'mgr', name: 'Manager' },
  { id: 'lead', name: 'Team Lead' },
  { id: 'arch', name: 'Solution Architect' },
  { id: 'cons', name: 'Consultant' },
];

const countries = [
  { id: 'US', name: 'United States' },
  { id: 'UK', name: 'United Kingdom' },
  { id: 'DE', name: 'Germany' },
  { id: 'FR', name: 'France' },
  { id: 'ES', name: 'Spain' },
  { id: 'JP', name: 'Japan' },
  { id: 'SG', name: 'Singapore' },
  { id: 'AU', name: 'Australia' },
  { id: 'BR', name: 'Brazil' },
  { id: 'IN', name: 'India' },
];

const holidayFirstNames = [
  'Emma',
  'Liam',
  'Olivia',
  'Noah',
  'Ava',
  'Isabella',
  'Sophia',
  'Jackson',
  'Lucas',
  'Aiden',
  'Yuki',
  'Chen',
  'María',
  'João',
  'Hans',
  'Sophie',
  'Raj',
  'Priya',
  'Wei',
  'Mei',
  'Carlos',
  'Ana',
  'Pierre',
  'Luis',
  'Nina',
  'Diego',
  'Fatima',
  'Ahmed',
  'Zara',
  'Alex',
  'Sasha',
  'Milan',
];

const holidayLastNames = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'García',
  'Silva',
  'Müller',
  'Tanaka',
  'Li',
  'Patel',
  'Kim',
  'Andersen',
  'Martinez',
  'Weber',
  'Singh',
  'Kumar',
  'Wang',
  'Chen',
  'Rodriguez',
  'Fernandez',
  'Dubois',
  'Santos',
  'Kowalski',
  'Ivanov',
  'Ahmed',
  'Khan',
  'Yamamoto',
  'López',
  'Jensen',
];

const generateHolidayUser = (userId: string) => {
  const firstName = getRandomElement(holidayFirstNames);
  const lastName = getRandomElement(holidayLastNames);

  return {
    id: userId,
    email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@example.com`,
    profile: {
      email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@example.com`,
      name: `${firstName} ${lastName}`,
      profilePicture: {
        url: `https://i.pravatar.cc/150?u=${userId}`,
        placeholder: `https://i.pravatar.cc/50?u=${userId}`,
      },
    },
    area: getRandomElement(areas),
    jobPosition: getRandomElement(jobCategories),
    country: getRandomElement(countries),
  };
};

export const createMockHolidayById = (id: string): THolidayDetail => {
  // Generate 100 unique users
  const users = Array.from({ length: 100 }, (_, index) =>
    generateHolidayUser(`USER${String(index + 1).padStart(3, '0')}`),
  );

  return {
    id,
    usersCount: users.length,
    date: '2024-12-25T00:00:00.000Z', // Example fixed date
    name: 'Christmas Day', // Example fixed name
    users,
  };
};
